import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// the translations
const resources = {
  en: {
    translation: {
      // General
      "Search pages, components, users…": "Search pages, components, users…",
      "Switch to Dark Mode": "Switch to Dark Mode",
      "Switch to Light Mode": "Switch to Light Mode",
      "Switch to Galaxy Mode": "Switch to Galaxy Mode",
      "Full screen": "Full screen",
      "Exit full screen": "Exit full screen",
      "Select Language": "Select Language",
      "English": "English",
      "Hindi": "Hindi",
      "Web Apps": "Web Apps",
      "Launcher": "Launcher",
      "Notifications": "Notifications",
      "unread messages": "unread messages",
      "Mark all read": "Mark all read",
      "View all notifications": "View all notifications",
      "Super Admin": "Super Admin",
      "Profile": "Profile",
      "Settings": "Settings",
      "Support": "Support",
      "Feedback": "Feedback",
      "Log out": "Log out",

      // Sidebar Menus
      "Menu": "Menu",
      "Dashboard": "Dashboard",
      "Analytics": "Analytics",
      "Ecommerce": "Ecommerce",
      "Hrms": "Hrms",
      "Job": "Job",
      "Pages": "Pages",
      "Authentication": "Authentication",
      "Login": "Login",
      "Register": "Register",
      "Forgot Password": "Forgot Password",
      "Reset Password": "Reset Password",
      "Two Factor": "Two Factor",
      "Lock Screen": "Lock Screen",
      "Error Pages": "Error Pages",
      "404 Error": "404 Error",
      "403 Forbidden": "403 Forbidden",
      "500 Server Error": "500 Server Error",
      "Starter Page": "Starter Page",
      "Apps": "Apps",
      "Chat": "Chat",
      "Calendar": "Calendar",
      "Email": "Email",
      "HRMS": "HRMS",
      "Job Portal": "Job Portal",
      "Users": "Users",
      "Components": "Components",
      "Basic UI Elements": "Basic UI Elements",
      "Alert": "Alert",
      "Avatar": "Avatar",
      "Badge": "Badge",
      "Breadcrumb": "Breadcrumb",
      "Button": "Button",
      "Collapsible": "Collapsible",
      "Dialog": "Dialog",
      "Dropdown Menu": "Dropdown Menu",
      "List": "List",
      "Link": "Link",
      "Ribbons": "Ribbons",
      "Utilities": "Utilities",
      "Embedded Video": "Embedded Video",
      "Legend": "Legend",
      "Navbars": "Navbars",
      "Pagination": "Pagination",
      "Popover": "Popover",
      "Progress": "Progress",
      "Separator": "Separator",
      "Sheet": "Sheet",
      "Skeleton": "Skeleton",
      "Slider": "Slider",
      "Tabs": "Tabs",
      "Toggle": "Toggle",
      "Tooltip": "Tooltip",
      "Typography": "Typography",
      "Advanced UI": "Advanced UI",
      "Accordion": "Accordion",
      "Alert Dialog": "Alert Dialog",
      "Aspect Ratio": "Aspect Ratio",
      "Block UI": "Block UI",
      "Combobox": "Combobox",
      "Command": "Command",
      "Counter Up": "Counter Up",
      "Drag & Drop": "Drag & Drop",
      "List Group": "List Group",
      "Media Object": "Media Object",
      "Ratings": "Ratings",
      "Spinner": "Spinner",
      "Sweet Alert": "Sweet Alert",
      "Swiper Slider": "Swiper Slider",
      "Toast": "Toast",
      "Tour": "Tour",
      "Tree": "Tree",
      "Watermark": "Watermark",
      "Form Elements": "Form Elements",
      "Advance Form": "Advance Form",
      "Checkbox": "Checkbox",
      "Date Picker": "Date Picker",
      "Radio Group": "Radio Group",
      "Input": "Input",
      "Input Group": "Input Group",
      "Input OTP": "Input OTP",
      "Native Select": "Native Select",
      "Resizable": "Resizable",
      "Select": "Select",
      "Switch": "Switch",
      "Textarea": "Textarea",
      "Tables": "Tables",
      "Basic Tables": "Basic Tables",
      "Grid.js Tables": "Grid.js Tables",
      "Charts": "Charts",
      "ApexCharts": "ApexCharts",
      "Chart.js": "Chart.js",
      "ECharts": "ECharts",
      "Maps": "Maps",
      "Leaflet Maps": "Leaflet Maps",
      "Vector Maps": "Vector Maps",
      "Google Maps": "Google Maps",
      "Icons": "Icons",
      "Lucide Icons": "Lucide Icons",
      "Remix Icons": "Remix Icons",
      "Font Awesome": "Font Awesome",
      "Database": "Database",
      "Extra": "Extra",
      "Multi Level Menu": "Multi Level Menu",
      "Level 1.1": "Level 1.1",
      "Level 1.2": "Level 1.2",
      "Level 2.1": "Level 2.1",
      "Level 2.2": "Level 2.2"
    }
  },
  hi: {
    translation: {
      // General
      "Search pages, components, users…": "पृष्ठ, घटक, उपयोगकर्ता खोजें...",
      "Switch to Dark Mode": "डार्क मोड में बदलें",
      "Switch to Light Mode": "लाइट मोड में बदलें",
      "Switch to Galaxy Mode": "गैलेक्सी मोड में बदलें",
      "Full screen": "पूर्ण स्क्रीन",
      "Exit full screen": "पूर्ण स्क्रीन से बाहर निकलें",
      "Select Language": "भाषा चुनें",
      "English": "अंग्रेज़ी (English)",
      "Hindi": "हिंदी (Hindi)",
      "Web Apps": "वेब ऐप्स",
      "Launcher": "लॉन्चर",
      "Notifications": "सूचनाएं",
      "unread messages": "अपठित संदेश",
      "Mark all read": "सभी को पढ़ा हुआ चिह्नित करें",
      "View all notifications": "सभी सूचनाएं देखें",
      "Super Admin": "सुपर एडमिन",
      "Profile": "प्रोफ़ाइल",
      "Settings": "सेटिंग्स",
      "Support": "सहायता",
      "Feedback": "प्रतिक्रिया",
      "Log out": "लॉग आउट",

      // Sidebar Menus
      "Menu": "मेनू",
      "Dashboard": "डैशबोर्ड",
      "Analytics": "एनालिटिक्स",
      "Ecommerce": "ई-कॉमर्स",
      "Hrms": "एचआरएमएस",
      "Job": "नौकरी",
      "Pages": "पेजेस",
      "Authentication": "प्रमाणीकरण",
      "Login": "लॉग इन",
      "Register": "रजिस्टर",
      "Forgot Password": "पासवर्ड भूल गए",
      "Reset Password": "पासवर्ड रीसेट करें",
      "Two Factor": "टू फैक्टर",
      "Lock Screen": "लॉक स्क्रीन",
      "Error Pages": "त्रुटि पृष्ठ",
      "404 Error": "404 त्रुटि",
      "403 Forbidden": "403 वर्जित",
      "500 Server Error": "500 सर्वर त्रुटि",
      "Starter Page": "स्टार्टर पेज",
      "Apps": "ऐप्स",
      "Chat": "चैट",
      "Calendar": "कैलेंडर",
      "Email": "ईमेल",
      "HRMS": "एचआरएमएस",
      "Job Portal": "जॉब पोर्टल",
      "Users": "उपयोगकर्ता",
      "Components": "घटक",
      "Basic UI Elements": "बुनियादी यूआई तत्व",
      "Alert": "अलर्ट",
      "Avatar": "अवतार",
      "Badge": "बैज",
      "Breadcrumb": "ब्रेडक्रंब",
      "Button": "बटन",
      "Collapsible": "कोलेप्सिबल",
      "Dialog": "संवाद",
      "Dropdown Menu": "ड्रॉपडाउन मेनू",
      "List": "सूची",
      "Link": "लिंक",
      "Ribbons": "रिबन",
      "Utilities": "उपयोगिताएँ",
      "Embedded Video": "एंबेडेड वीडियो",
      "Legend": "लीजेंड",
      "Navbars": "नेवबार",
      "Pagination": "पेजिनेशन",
      "Popover": "पॉपओवर",
      "Progress": "प्रगति",
      "Separator": "सेपरेटर",
      "Sheet": "शीट",
      "Skeleton": "स्केलेटन",
      "Slider": "स्लाइडर",
      "Tabs": "टैब",
      "Toggle": "टॉगल",
      "Tooltip": "टूलटिप",
      "Typography": "टाइपोग्राफी",
      "Advanced UI": "उन्नत यूआई",
      "Accordion": "अकॉर्डियन",
      "Alert Dialog": "अलर्ट डायलॉग",
      "Aspect Ratio": "एस्पेक्ट रेशियो",
      "Block UI": "ब्लॉक यूआई",
      "Combobox": "कॉम्बोबॉक्स",
      "Command": "कमांड",
      "Counter Up": "काउंटर अप",
      "Drag & Drop": "ड्रैग एंड ड्रॉप",
      "List Group": "सूची समूह",
      "Media Object": "मीडिया ऑब्जेक्ट",
      "Ratings": "रेटिंग",
      "Spinner": "स्पिनर",
      "Sweet Alert": "स्वीट अलर्ट",
      "Swiper Slider": "स्वाइपर स्लाइडर",
      "Toast": "टोस्ट",
      "Tour": "टूर",
      "Tree": "ट्री",
      "Watermark": "वॉटरमार्क",
      "Form Elements": "फॉर्म तत्व",
      "Advance Form": "एडवांस फॉर्म",
      "Checkbox": "चेकबॉक्स",
      "Date Picker": "डेट पिकर",
      "Radio Group": "रेडियो ग्रुप",
      "Input": "इनपुट",
      "Input Group": "इनपुट ग्रुप",
      "Input OTP": "इनपुट ओटीपी",
      "Native Select": "नेटिव सेलेक्ट",
      "Resizable": "रिसाइजेबल",
      "Select": "सेलेक्ट",
      "Switch": "स्विच",
      "Textarea": "टेक्स्ट एरिया",
      "Tables": "टेबल्स",
      "Basic Tables": "बुनियादी टेबल",
      "Grid.js Tables": "Grid.js टेबल",
      "Charts": "चार्ट",
      "ApexCharts": "एपेक्सचार्ट",
      "Chart.js": "Chart.js",
      "ECharts": "ईचार्ट",
      "Maps": "नक्शे",
      "Leaflet Maps": "लीफलेट मैप्स",
      "Vector Maps": "वेक्टर मैप्स",
      "Google Maps": "गूगल मैप्स",
      "Icons": "आइकन",
      "Lucide Icons": "ल्यूसिड आइकन",
      "Remix Icons": "रीमिक्स आइकन",
      "Font Awesome": "फ़ॉन्ट बहुत बढ़िया",
      "Database": "डेटाबेस",
      "Extra": "अतिरिक्त",
      "Multi Level Menu": "मल्टी लेवल मेनू",
      "Level 1.1": "स्तर 1.1",
      "Level 1.2": "स्तर 1.2",
      "Level 2.1": "स्तर 2.1",
      "Level 2.2": "स्तर 2.2"
    }
  },
  ar: {
    translation: {
      "Search pages, components, users…": "ابحث عن الصفحات والمكونات والمستخدمين...",
      "Switch to Dark Mode": "التبديل إلى الوضع المظلم",
      "Switch to Light Mode": "التبديل إلى وضع الإضاءة",
      "Switch to Galaxy Mode": "التبديل إلى وضع المجرة",
      "Full screen": "ملء الشاشة",
      "Exit full screen": "الخروج من ملء الشاشة",
      "Select Language": "اختر اللغة",
      "English": "الإنجليزية (English)",
      "Hindi": "الهندية (Hindi)",
      "Arabic": "العربية (Arabic)",
      "Italian": "الإيطالية (Italian)",
      "Web Apps": "تطبيقات الويب",
      "Launcher": "المشغل",
      "Notifications": "الإشعارات",
      "unread messages": "رسائل غير مقروءة",
      "Mark all read": "تحديد الكل كمقروء",
      "View all notifications": "عرض كل الإشعارات",
      "Super Admin": "مشرف متميز",
      "Profile": "الملف الشخصي",
      "Settings": "الإعدادات",
      "Support": "الدعم",
      "Feedback": "تعليقات",
      "Log out": "تسجيل الخروج",
      "Menu": "القائمة",
      "Dashboard": "لوحة القيادة",
      "Analytics": "التحليلات",
      "Ecommerce": "التجارة الإلكترونية",
      "Hrms": "الموارد البشرية",
      "Job": "وظيفة",
      "Pages": "الصفحات",
      "Authentication": "المصادقة",
      "Login": "تسجيل الدخول",
      "Register": "تسجيل",
      "Forgot Password": "نسيت كلمة المرور",
      "Reset Password": "إعادة تعيين كلمة المرور",
      "Two Factor": "عاملان",
      "Lock Screen": "قفل الشاشة",
      "Error Pages": "صفحات الخطأ",
      "404 Error": "خطأ 404",
      "403 Forbidden": "403 ممنوع",
      "500 Server Error": "خطأ خادم 500",
      "Starter Page": "صفحة البداية",
      "Apps": "التطبيقات",
      "Chat": "دردشة",
      "Calendar": "التقويم",
      "Email": "البريد الإلكتروني",
      "HRMS": "الموارد البشرية",
      "Job Portal": "بوابة الوظائف",
      "Users": "المستخدمون",
      "Components": "المكونات",
      "Basic UI Elements": "عناصر واجهة المستخدم الأساسية",
      "Alert": "تنبيه",
      "Avatar": "صورة رمزية",
      "Badge": "شارة",
      "Breadcrumb": "مسار التنقل",
      "Button": "زر",
      "Collapsible": "قابل للطي",
      "Dialog": "حوار",
      "Dropdown Menu": "قائمة منسدلة",
      "List": "قائمة",
      "Link": "رابط",
      "Ribbons": "شرائط",
      "Utilities": "أدوات مساعدة",
      "Embedded Video": "فيديو مضمن",
      "Legend": "وسيلة إيضاح",
      "Navbars": "أشرطة التنقل",
      "Pagination": "ترقيم الصفحات",
      "Popover": "بوب أوفر",
      "Progress": "تقدم",
      "Separator": "فاصل",
      "Sheet": "ورقة",
      "Skeleton": "هيكل",
      "Slider": "منزلق",
      "Tabs": "علامات تبويب",
      "Toggle": "تبديل",
      "Tooltip": "تلميح الأداة",
      "Typography": "الطباعة",
      "Advanced UI": "واجهة مستخدم متقدمة",
      "Accordion": "أكورديون",
      "Alert Dialog": "مربع حوار التنبيه",
      "Aspect Ratio": "نسبة العرض إلى الارتفاع",
      "Block UI": "حظر واجهة المستخدم",
      "Combobox": "مربع تحرير وسرد",
      "Command": "أمر",
      "Counter Up": "عداد لأعلى",
      "Drag & Drop": "السحب والإفلات",
      "List Group": "مجموعة القائمة",
      "Media Object": "كائن الوسائط",
      "Ratings": "التقييمات",
      "Spinner": "دوار",
      "Sweet Alert": "تنبيه حلو",
      "Swiper Slider": "شريط التمرير",
      "Toast": "نخب",
      "Tour": "جولة",
      "Tree": "شجرة",
      "Watermark": "علامة مائية",
      "Form Elements": "عناصر النموذج",
      "Advance Form": "نموذج متقدم",
      "Checkbox": "خانة اختيار",
      "Date Picker": "منتقي التاريخ",
      "Radio Group": "مجموعة أزرار الراديو",
      "Input": "إدخال",
      "Input Group": "مجموعة الإدخال",
      "Input OTP": "إدخال OTP",
      "Native Select": "تحديد أصلي",
      "Resizable": "قابل لتغيير الحجم",
      "Select": "تحديد",
      "Switch": "تبديل",
      "Textarea": "منطقة نصية",
      "Tables": "الجداول",
      "Basic Tables": "الجداول الأساسية",
      "Grid.js Tables": "جداول Grid.js",
      "Charts": "الرسوم البيانية",
      "ApexCharts": "ApexCharts",
      "Chart.js": "Chart.js",
      "ECharts": "ECharts",
      "Maps": "الخرائط",
      "Leaflet Maps": "خرائط ليفليت",
      "Vector Maps": "الخرائط المتجهة",
      "Google Maps": "خرائط جوجل",
      "Icons": "أيقونات",
      "Lucide Icons": "أيقونات لوسيد",
      "Remix Icons": "أيقونات ريمكس",
      "Font Awesome": "فونت أوسوم",
      "Database": "قاعدة البيانات",
      "Extra": "إضافي",
      "Multi Level Menu": "قائمة متعددة المستويات",
      "Level 1.1": "المستوى 1.1",
      "Level 1.2": "المستوى 1.2",
      "Level 2.1": "المستوى 2.1",
      "Level 2.2": "المستوى 2.2"
    }
  },
  it: {
    translation: {
      "Search pages, components, users…": "Cerca pagine, componenti, utenti...",
      "Switch to Dark Mode": "Passa alla modalità oscura",
      "Switch to Light Mode": "Passa alla modalità chiara",
      "Switch to Galaxy Mode": "Passa alla modalità Galaxy",
      "Full screen": "Schermo intero",
      "Exit full screen": "Esci dallo schermo intero",
      "Select Language": "Seleziona lingua",
      "English": "Inglese (English)",
      "Hindi": "Hindi (Hindi)",
      "Arabic": "Arabo (Arabic)",
      "Italian": "Italiano (Italian)",
      "Web Apps": "App Web",
      "Launcher": "Launcher",
      "Notifications": "Notifiche",
      "unread messages": "messaggi non letti",
      "Mark all read": "Segna tutti come letti",
      "View all notifications": "Vedi tutte le notifiche",
      "Super Admin": "Super Admin",
      "Profile": "Profilo",
      "Settings": "Impostazioni",
      "Support": "Supporto",
      "Feedback": "Feedback",
      "Log out": "Disconnettiti",
      "Menu": "Menu",
      "Dashboard": "Dashboard",
      "Analytics": "Analisi",
      "Ecommerce": "E-commerce",
      "Hrms": "Risorse Umane",
      "Job": "Lavoro",
      "Pages": "Pagine",
      "Authentication": "Autenticazione",
      "Login": "Accesso",
      "Register": "Registrati",
      "Forgot Password": "Password dimenticata",
      "Reset Password": "Reimposta password",
      "Two Factor": "Due fattori",
      "Lock Screen": "Blocca schermo",
      "Error Pages": "Pagine di errore",
      "404 Error": "Errore 404",
      "403 Forbidden": "403 Vietato",
      "500 Server Error": "Errore del server 500",
      "Starter Page": "Pagina iniziale",
      "Apps": "App",
      "Chat": "Chat",
      "Calendar": "Calendario",
      "Email": "Email",
      "HRMS": "Risorse umane",
      "Job Portal": "Portale del lavoro",
      "Users": "Utenti",
      "Components": "Componenti",
      "Basic UI Elements": "Elementi dell'interfaccia utente di base",
      "Alert": "Avviso",
      "Avatar": "Avatar",
      "Badge": "Distintivo",
      "Breadcrumb": "Pangrattato",
      "Button": "Pulsante",
      "Collapsible": "Pieghevole",
      "Dialog": "Dialogo",
      "Dropdown Menu": "Menu a discesa",
      "List": "Elenco",
      "Link": "Link",
      "Ribbons": "Nastri",
      "Utilities": "Utilità",
      "Embedded Video": "Video incorporato",
      "Legend": "Leggenda",
      "Navbars": "Barre di navigazione",
      "Pagination": "Impaginazione",
      "Popover": "Popover",
      "Progress": "Progresso",
      "Separator": "Separatore",
      "Sheet": "Foglio",
      "Skeleton": "Scheletro",
      "Slider": "Dispositivo di scorrimento",
      "Tabs": "Schede",
      "Toggle": "Attiva/disattiva",
      "Tooltip": "Creazione comando",
      "Typography": "Tipografia",
      "Advanced UI": "Interfaccia utente avanzata",
      "Accordion": "Fisarmonica",
      "Alert Dialog": "Finestra di avviso",
      "Aspect Ratio": "Proporzioni",
      "Block UI": "Blocca interfaccia utente",
      "Combobox": "Casella combinata",
      "Command": "Comando",
      "Counter Up": "Contatore",
      "Drag & Drop": "Trascina e rilascia",
      "List Group": "Gruppo di elenchi",
      "Media Object": "Oggetto multimediale",
      "Ratings": "Valutazioni",
      "Spinner": "Filatore",
      "Sweet Alert": "Avviso dolce",
      "Swiper Slider": "Dispositivo di scorrimento Swiper",
      "Toast": "Brindisi",
      "Tour": "Tour",
      "Tree": "Albero",
      "Watermark": "Filigrana",
      "Form Elements": "Elementi del modulo",
      "Advance Form": "Modulo avanzato",
      "Checkbox": "Casella di controllo",
      "Date Picker": "Selettore data",
      "Radio Group": "Gruppo radio",
      "Input": "Ingresso",
      "Input Group": "Gruppo di input",
      "Input OTP": "Inserisci OTP",
      "Native Select": "Selezione nativa",
      "Resizable": "Ridimensionabile",
      "Select": "Seleziona",
      "Switch": "Cambia",
      "Textarea": "Area di testo",
      "Tables": "Tabelle",
      "Basic Tables": "Tabelle di base",
      "Grid.js Tables": "Tabelle Grid.js",
      "Charts": "Grafici",
      "ApexCharts": "ApexCharts",
      "Chart.js": "Chart.js",
      "ECharts": "ECharts",
      "Maps": "Mappe",
      "Leaflet Maps": "Mappe a foglia",
      "Vector Maps": "Mappe vettoriali",
      "Google Maps": "Google Maps",
      "Icons": "Icone",
      "Lucide Icons": "Icone lucide",
      "Remix Icons": "Icone remix",
      "Font Awesome": "Font Awesome",
      "Database": "Banca dati",
      "Extra": "Extra",
      "Multi Level Menu": "Menu a più livelli",
      "Level 1.1": "Livello 1.1",
      "Level 1.2": "Livello 1.2",
      "Level 2.1": "Livello 2.1",
      "Level 2.2": "Livello 2.2"
    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
